import InteractionsDashboard from './InteractionsDashboard'
export default InteractionsDashboard
